<template>
  <div class="home container">
    <div class="row mt-4">
      <div class="col col-2">
        <img
          src="images/people/adam_godzik.jpg"
          class="img-fluid"
          alt="Adam Godzik"
        />
      </div>
      <div class="col col-10">
        <h1>Welcome</h1>
        Physicists, biologists and computer scientists meet together to
        understand proteins. If you want to know more about what (and how and
        why) we do, read on.
      </div>
    </div>

    <div class="row mt-4">
      <div class="col">
        <h1>Research</h1>
        <p>
          Our research is focused on proteins. We try to combine insights from
          physics and biology to answer basic questions about the relation
          between the protein sequence and its structure and function. From
          physics we know that proteins are ruled by universal laws - at
          equilibrium they are at the free energy minimum. From biology we know
          that proteins come in families and studying relations in such families
          we can learn more about how changes in protein sequences influence
          their structures and functions. You may find more in our

          <router-link to="publications" title="Publications"
            >publications</router-link
          >
          and
          <router-link to="servers" title="Servers"
            >bioinformatics servers</router-link
          >.
        </p>
      </div>
    </div>
    <div class="row mt-4">
      <h1>Most recent web servers</h1>
      <div class="col col-4">
        <img
          src="images/servers/modflex_full.png"
          class="img-fluid"
          alt="ModFlex view"
        />
        <a href="http://modflex.org"><b>Mod</b>Flex</a>: The ModFlex server
        provides an interface with multiple options and tools, which make it
        possible to explore structural diversity in the available modeling
        templates and make an optimal choice.
      </div>
      <div class="col col-4">
        <img
          src="images/servers/pdbflex_full.png"
          class="img-fluid"
          alt="PDBlex view"
        />
        <a href="http://pdbflex.org">PDBflex</a>: a database that explores the
        intrinsic flexibility of protein structures by analyzing structural
        variations between different depositions and chains in asymmetric unit
        of the same protein in PDB. It allows to easily identify regions and
        types of structural flexibility present in a protein of interest.
      </div>
      <div class="col col-4">
        <img
          src="images/servers/cancer3d_full.png"
          class="img-fluid"
          alt="PDBlex view"
        />
        <a href="http://cancer3d.org">Cancer3D</a>: a database that puts
        together information on somatic missense mutations from TCGA and CCLE,
        allowing users to explore two different cancer-related problems at the
        same time: drug sensitivity/biomarker identification and prediction of
        cancer drivers.
      </div>
    </div>

    <div class="row mt-4 mb-3">
      <div class="col">
        <h1>Updated versions of our web servers:</h1>
        <ul>
          <li>
            <a href="http://posa.godziklab.org">POSA</a>: a user-driven,
            interactive multiple protein structure alignment server.
          </li>
          <li>
            <a href="http://ffas.godziklab.org">FFAS-3D</a>: improving fold
            recognition by including optimized structural features and template
            re-ranking.
          </li>
          <li>
            <a href="http://xtalpred.godziklab.org">XtalPred-RF</a>: Improving
            the chances of successful protein structure determination with a
            random forest classifier
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
};
</script>
